import type { AppRouteRecordRaw } from '@mp/types/router'

// 过滤路由
export function filterPermissionRouter(router: AppRouteRecordRaw[], permissions: string[]) {
  return router.map((route) => {
    // 深拷贝路由对象
    const newRoute = { ...route }

    // 检查当前路由是否需要权限
    const routePermissions = newRoute.meta?.permission as string[] | undefined
    if (routePermissions?.length) {
      // 如果当前路由需要权限但用户没有对应权限,返回null
      if (!routePermissions.some(p => permissions?.includes(p)))
        return null
    }

    // 如果有子路由，递归过滤
    if (newRoute.children?.length) {
      // 过滤子路由
      const filteredChildren = newRoute.children.filter((child) => {
        const childPermissions = child.meta?.permission as string[] | undefined
        // 如果子路由需要权限，检查是否有权限
        if (childPermissions?.length)
          return childPermissions.some((p: string) => permissions?.includes(p))

        // 如果子路由不需要权限，保留
        return true
      })

      // 更新过滤后的子路由
      newRoute.children = filteredChildren

      // 如果所有子路由都被过滤掉了，返回null
      if (filteredChildren.length === 0)
        return null
    }

    return newRoute
  }).filter(Boolean) as AppRouteRecordRaw[]
}
